import Marker from '../Marker';
import subpixel from '../util/canvasSubpixelOffset';

/**
 * Draws vertical bands highlighting the extended hours sessions on each panel
 * Note: the extended data itself is rendered as normal via the price indicator, this
 * is just for the vertical band rendering.
 */
export default class ExtendedHoursMarker extends Marker {
	getDefaultParams() {
		return {
			style: this.panel.core.getStyle('marker.extendedHours')
		};
	}

	getPrePostData(dataIn) {
		return {
			pre: dataIn['PreMarketTrading'] || [],
			post: dataIn['PostMarketTrading'] || []
		};
	}

	render(dataIn) {
		const data = this.getPrePostData(dataIn);

		if (data.pre.length === 0 && data.post.length === 0) return;

		const ctx = this.panel.rootContext;

		// draw pre rects
		ctx.beginPath();
		ctx.fillStyle = this.params.style.preMarket.background.color;
		Object.keys(data.pre).forEach(key => {
			const val = data.pre[key];
			subpixel.rect(ctx, val.left, 1, val.width, val.height - 2);
		});
		ctx.fill();

		// draw post rects
		ctx.beginPath();
		ctx.fillStyle = this.params.style.postMarket.background.color;
		Object.keys(data.post).forEach(key => {
			const val = data.post[key];
			subpixel.rect(ctx, val.left, 1, val.width, val.height - 2);
		});
		ctx.fill();

		// draw pre start line
		ctx.beginPath();
		ctx.lineWidth =
			this.params.style.preMarket.startLine.width ||
			this.params.style.width;
		ctx.strokeStyle =
			this.params.style.preMarket.startLine.color ||
			this.params.style.color;
		Object.keys(data.pre).forEach(key => {
			const val = data.pre[key];
			subpixel.moveTo(ctx, val.left, 1);
			subpixel.lineTo(ctx, val.left, 1 + val.height - 3);
		});
		ctx.stroke();

		// draw pre end line
		ctx.beginPath();
		ctx.lineWidth =
			this.params.style.preMarket.stopLine.width ||
			this.params.style.width;
		ctx.strokeStyle =
			this.params.style.preMarket.stopLine.color ||
			this.params.style.color;
		Object.keys(data.pre).forEach(key => {
			const val = data.pre[key];
			subpixel.moveTo(ctx, val.left + val.width, 1);
			subpixel.lineTo(ctx, val.left + val.width, 1 + val.height - 3);
		});
		ctx.stroke();

		// draw post start line
		ctx.beginPath();
		ctx.lineWidth =
			this.params.style.postMarket.startLine.width ||
			this.params.style.width;
		ctx.strokeStyle =
			this.params.style.postMarket.startLine.color ||
			this.params.style.color;
		Object.keys(data.post).forEach(key => {
			const val = data.pre[key];
			subpixel.moveTo(ctx, val.left, 1);
			subpixel.lineTo(ctx, val.left, 1 + val.height - 3);
		});
		ctx.stroke();
	}
}
